module.exports = new __parcel__URL__("clock-2.c67f065d.svg").toString();